export * from './login';
export * from './session';
export * from './user';
export * from './xsrf';


import {loginReducer as login} from './login';
import {sessionReducer as session} from './session';
import {userReducer as user} from './user';
import {websiteReducer as Website} from './website';
import {xsrfReducer as xsrf} from './xsrf';
import {linkReducer as Links} from "./links";
import {blogReducer as Blog} from "./blog";
import {tagsReducer as Tags} from "./tags";
import {adReducer as Ads} from "./advertise";

export const reducers = {Blog,login,session,user,Website,xsrf,Links,Tags, Ads};
